import { SearchFilterOption } from "../../../shared/components/search-bar/search-filter/search-filter.component";
import { yesNoOptions } from "../../../shared/constants/components";
import { UserInfo } from "../../../shared/types/user-info";
import { InternalProvider } from "./internal-provider.type";

//#region Search Filter Options
export const getInternalProviderSearchFilterOptions = (
  _user: UserInfo,
  config?: {
    shown?: string[];
    hidden?: string[];
  },
): SearchFilterOption<InternalProvider>[] => {
  const { shown, hidden } = config || {};

  return (
    [
      { value: "name", label: "Name", disabled: false },
      {
        value: "enabled",
        label: "Enabled",
        disabled: false,
        inputType: "dropdown",
        options: [...yesNoOptions],
        condition: "$eq",
      },
    ] as SearchFilterOption<InternalProvider>[]
  ).filter((opt) => (shown ? shown.includes(opt.value) : true) && (hidden ? !hidden.includes(opt.value) : true));
};

//#endregion
